import { gql } from "@apollo/client"

export const BULK_ASSIGNMENT = gql`
  mutation DMSBulkAssign(
    $tripIds: [Int!]!
    $dockId: Int
    $dockSupervisorId: Int
  ) {
    bulkAssignment(
      tripIds: $tripIds
      dockId: $dockId
      dockSupervisorId: $dockSupervisorId
    ) {
      trips {
        id
        dock {
          id
          name
        }
        dockSupervisor {
          id
          fullName
        }
      }
    }
  }
`

export const ARRIVED_DOCK = gql`
  mutation ArrivedDockMutation(
    $tripId: String
    $stepId: String
    $timestamp: DateTime
  ) {
    logTripStep(
      trip: $tripId
      timestamp: $timestamp
      stepId: $stepId
      latitude: 12.412
      longitude: 23.24
    ) {
      trip {
        id
        tripLogs {
          id
          step {
            id
            stepId
          }
          timestamp
        }
      }
    }
  }
`

export const SAVE_ITEM_DETAILS = gql`
  mutation SaveItemDetails(
    $tripId: Int!
    $tripIdID: ID
    $bookings: [BookInput]
  ) {
    vehicalLoadingList(tripId: $tripId, bookings: $bookings) {
      trip {
        id
        uuid
        estimatedDespatchTime
        loadingPattern
        despatchOtp
        aggregator {
          id
          fullName
        }
        scheduledVehicle {
          id
          driver {
            id
            fullName
            number
          }
          registrationNumber
          vehicleType {
            id
            category
            name
            capacity
            capacityUnit {
              id
              name
              codename
            }
          }
        }
        vehicle {
          id
          driver {
            id
            fullName
            number
          }
          registrationNumber
          vehicleType {
            id
            category
            name
            capacity
            capacityUnit {
              id
              name
              codename
            }
          }
        }
        dock {
          id
          name
        }
        dockSupervisor {
          id
          fullName
          firstName
          lastName
          number
        }
        tripLogs {
          id
          step {
            id
            stepId
          }
        }
        orders {
          id
          trackingCode
          user {
            id
            fullName
          }
          shippingAddress {
            id
            village
            taluka
            address
          }
          orderStatus
          bookingsByTrip(tripId: $tripIdID) {
            id
            loadingSequence
            orderItem {
              sellableItem {
                id
                name
                codename
              }
              quantity
            }
            despatchedQuantity
            despatchPhoto {
              id
              url
            }
            driverDespatchRemark
            driverVerification
          }
        }
      }
    }
  }
`

export const RESOLVE_REMARK = gql`
  mutation ResolveRemark(
    $tripId: Int!
    $tripIdID: ID!
    $bookings: [DriverVerificationInput]
  ) {
    driverLoadingVerification(tripId: $tripId, bookings: $bookings) {
      trip {
        id
        orders {
          id
          trackingCode
          user {
            id
            fullName
          }
          shippingAddress {
            id
            village
            taluka
            address
          }
          orderStatus
          bookingsByTrip(tripId: $tripIdID) {
            id
            loadingSequence
            orderItem {
              sellableItem {
                id
                name
                codename
              }
              quantity
            }
            despatchedQuantity
            despatchPhoto {
              id
              url
            }
            driverDespatchRemark
            driverVerification
          }
        }
      }
    }
  }
`
